// components/portfolio/add-asset/components/AllocationInput.js
import React from 'react';

const AllocationInput = ({ value, onChange }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        Hedef Yüzde
      </label>
      <div className="flex items-center space-x-2">
        <input
          type="number"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-24 px-3 py-2 border rounded-md
            dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100
            focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          min="0"
          max="100"
          step="0.1"
        />
        <span className="text-gray-600 dark:text-gray-400">%</span>
      </div>
    </div>
  );
};

export default AllocationInput;